import React from "react";
import styles from "./loader.module.scss";
import classnames from "classnames";
import { LuLoader } from "react-icons/lu";

export const Loader: React.FC<{ className?: string; scale?: number }> = ({ className, scale }) => {
  return (
    <span
      className={classnames(styles.loader, className)}
      style={{ transform: scale ? `translateZ(0) scale(${scale})` : "translateZ(0) scale(1)" }}
    />
  );
};

export const Spinner: React.FC<{ className?: string; width?: string; height?: string }> = ({ className, width, height }) => {
  return (
    <div
      className={classnames(styles.spinner, className)}
      style={{
        width: width ?? "1em",
        height: height ?? "1em",
      }}
    >
      <LuLoader className={styles.spinnerIcon} />
    </div>
  );
};
